<template>
  <div
    class="lamp"
    :style="{ 'background-color': online ? 'green' : 'red' }"
    :class="{ online: online }"
  ></div>
</template>

<script>
export default {
  name: "Online",
  props: {
    online: {
      type: [Boolean, Number, String],
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.lamp {
  height: 20px;
  width: 20px;
  display: table;
  margin: 0 auto;
  border-radius: 50%;
}
</style>
